module.exports = __webpack_public_path__ + "img/logo_menu.0febac74.svg";